import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { Order } from '~/types/order'

interface OrderState {
  order: Order | undefined
  isGa4AlreadyLogged?: boolean
}

const initialState: OrderState = {
  order: undefined,
}

const slice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setOrder: (state, action: PayloadAction<OrderState['order']>) => ({
      ...state,
      order: action.payload,
    }),

    setOrderIsGa4Logged: (state, action: PayloadAction<OrderState['isGa4AlreadyLogged']>) => ({
      ...state,
      isGa4AlreadyLogged: action.payload,
    }),
  },
})

export const selectOrder = (state: RootState): OrderState['order'] => {
  return state.order.order
}

export const selectOrderIsGa4AlreadyLogged = (state: RootState): OrderState['isGa4AlreadyLogged'] => {
  return state.order.isGa4AlreadyLogged
}

export const { setOrder: setOrderActionCreator, setOrderIsGa4Logged } = slice.actions

export default slice.reducer
